/**
 * Mono PCM sample rate shared between the resync feature's main-thread runner
 * (`workerRunner.ts`, which now decodes — cue-forge-5nj) and its worker
 * (`../workers/resync.worker.ts`, which now only receives already-decoded
 * PCM at this rate). Kept in its own module — rather than exported directly
 * from the worker file — so importing it never pulls the worker's
 * `self.onmessage`-assigning side effects into the main-thread bundle.
 */
export const RESYNC_TARGET_RATE = 8000;
